import { createContext } from "react";
// import { AdminContext } from "./adminContext";
// import { NotificationContext } from "./notificationContext";

export type ContextProps = {};

export const DebatesContext = createContext({} as ContextProps);

export const DebatesProvider = ({ children }: { children: JSX.Element }) => {
  // const { localCountry } = useContext(AdminContext);
  // const { openNotificationWithIcon } = useContext(NotificationContext);

  return <DebatesContext.Provider value={{}}>{children}</DebatesContext.Provider>;
};
